import { DeleteOutline } from '@mui/icons-material';
import { Stack } from '@mui/material';
import { PageTitle, RoutedTabs } from 'components';
import { useFindDeletedActivitiesQuery, useFindDeletedIndividualsQuery } from 'gql';
import { ActivitiesTable } from 'modules/activities/components/ActivitiesTable';
import { IndividualsTable } from 'modules/individuals/components/IndividualsTable';
import { IndividualActions } from 'modules/individuals/components/IndividualActions/IndividualActions';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSearchParams } from 'react-router-dom';

type Tab = { displayString: string, navigationString: string; };

export const RestorationPage: React.FC = () => {
  const { formatMessage } = useIntl();
  const [searchParams] = useSearchParams();

  const currentTab = searchParams.get('tab') || 'activities';

  const { data: activitiesQuery, isFetching: isFetchingActivities } = useFindDeletedActivitiesQuery();
  const { data: deletedIndividualsQuery, isFetching: isFetchingDeletedIndividuals } = useFindDeletedIndividualsQuery();

  const tabs: Tab[] = [
    { displayString: formatMessage({ id: 'Activities' }), navigationString: 'activities' },
    { displayString: formatMessage({ id: 'Known individuals' }), navigationString: 'individuals' }
  ];

  return (
    <Stack mb={{ xs: 9, md: 0 }} gap={1}>
      <PageTitle icon={<DeleteOutline />} title={formatMessage({ id: 'Recycle Bin' })} />

      <RoutedTabs
        tabs={tabs}
        navigationStyle='queryParam'
        queryParam='tab'
        defaultNavigation='activities'
        variant='scrollable'
        scrollButtons='auto'
      />

      {currentTab === 'activities' && (
        <ActivitiesTable
          loading={isFetchingActivities}
          activities={activitiesQuery?.deletedActivities ?? []}
        />
      )}

      {currentTab === 'individuals' && (
        <IndividualsTable
          storageKey='deleted-individuals-table'
          individuals={deletedIndividualsQuery?.deletedIndividuals ?? []}
          loading={isFetchingDeletedIndividuals && !deletedIndividualsQuery}
          isFetching={isFetchingDeletedIndividuals}
          filterMode='client'
        />
      )}
    </Stack>
  );
};